import React from 'react';
import NoAccessOverlay from '@/finsight/ui/common/components/NoAccessOverlay';
import {
  PORTFOLIO_MONITOR_PAGE_TITLE,
  portfolioMonitorImageCaption,
  portfolioMonitorNoAccessDescription,
  portfolioMonitorNoAccessFeatures,
} from '@/finsight/ui/components/portfolioMonitor/constants';
import image from '@/finsight/ui/assets/noAccess/portfolioMonitorNoAccess.webp';
import GetStartedButton from '@/finsight/ui/components/portfolioMonitor/GetStartedButton';

const getPortfolioMonitorOverlay = (isCustomButton, isDesktopOnly = false) => (
  <NoAccessOverlay
    title={ PORTFOLIO_MONITOR_PAGE_TITLE }
    features={ portfolioMonitorNoAccessFeatures }
    description={ portfolioMonitorNoAccessDescription }
    imageCaption={ portfolioMonitorImageCaption }
    image={ image }
    customButton={ isCustomButton && GetStartedButton }
    isDesktopOnly={ isDesktopOnly }
  />
);

export default getPortfolioMonitorOverlay;
